<!-- Do not change this file. -->

<template>
  <div class="text-uppercase fs-6 my-auto">
    <span class="badge bg-primary d-block d-sm-none">xs</span>
    <span class="badge bg-primary d-none d-sm-block d-md-none">sm</span>
    <span class="badge bg-primary d-none d-md-block d-lg-none">md</span>
    <span class="badge bg-primary d-none d-lg-block d-xl-none">lg</span>
    <span class="badge bg-primary d-none d-xl-block d-xxl-none">xl</span>
    <span class="badge bg-primary d-none d-xxl-block">xxl</span>
  </div>
</template>

<script>
/* Do not change this file. */

export default {
  name: "TheBreakpoints"
};
</script>
